export const formatDateToIST = (utcDateString: string): string => {
    if (!utcDateString) return "";
    // Ensure it's parsed as UTC
    const date = new Date(utcDateString + "Z");
    return new Intl.DateTimeFormat("en-IN", {
        timeZone: "Asia/Kolkata", // Force IST
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // 12h format with AM/PM
    })
        .format(date)
        .replace(",", ""); // remove comma for clean look
};